export default __webpack_public_path__ + "static/media/1988.d29102f6.png";